<script setup>
import {defineProps} from 'vue'
import {useOrderDataStore} from "@/stores/orderDataStore";
import StoreCredit from "@/components/StoreCredit/StoreCredit.vue"
import MoneyReturn from "@/components/IbanReturn/MoneyReturn.vue"
import VivaReturn from "@/components/VivaReturn/VivaReturn.vue"
import ShopifyReturn from "@/components/ShopifyReturn/ShopifyReturn.vue"
import KlarnaReturn from "@/components/KlarnaReturn/KlarnaReturn.vue";

const orderDataStore = useOrderDataStore();

defineProps({
  modelValue: String,
})


</script>

<template>

  <!-- Store credit -->
  <StoreCredit
      v-if="orderDataStore.refundMethods.some(method => method.key.includes('credit'))"
      :refundMethod="orderDataStore.refundMethods.find(m => m.key === 'credit')"
  />

  <!-- IBAN return -->
  <MoneyReturn
      v-if="orderDataStore.refundMethods.some(method => method.key.includes('iban'))"
      :refundMethod="orderDataStore.refundMethods.find(m => m.key === 'iban')"
  />

  <!-- Shopify return -->
  <ShopifyReturn
      v-if="orderDataStore.refundMethods.some(method => method.key.includes('shopify'))"
      :refundMethod="orderDataStore.refundMethods.find(m => m.key === 'shopify')"
  />

  <!-- Viva return -->
  <VivaReturn
      v-if="orderDataStore.refundMethods.some(method => method.key.includes('viva'))"
      :refundMethod="orderDataStore.refundMethods.find(m => m.key === 'viva')"
  />
  <KlarnaReturn v-if="orderDataStore.refundMethods.some(method => method.key.includes('klarna'))"
                :refundMethod="orderDataStore.refundMethods.find(m => m.key === 'klarna')"
  />
</template>



